import { NsInputter } from 'components/common/ns-inputter/NsInputter';
import { NsInputterValidations } from 'components/common/ns-inputter/NsInputterValidations';
import { NsInput } from 'components/common/ns-input/NsInput';
import NsInputterEvent from '../ns-inputter/NsInputterEvent';

type NsPostcodeInputProps = {
  id?: string;
  label?: string;
  name?: string;
  testId?: string;
  onChange?: (event: NsInputterEvent) => void;
  value?: string;
  inputAttributes?: Record<string, string | boolean>;
};

export const NsPostcodeInput = ({
  id = 'postcode',
  label = 'Post code',
  name = 'postcode',
  value,
  testId,
  onChange,
  inputAttributes = {}
}: NsPostcodeInputProps) => {
  const validations = [
    NsInputterValidations.isRequired,
    NsInputterValidations.isPostcode(true)
  ];
  return (
    <NsInputter
      validation={validations}
      value={value}
      name={name}
      onChange={onChange}
    >
      <NsInput
        label={label}
        name={name}
        id={id}
        testId={testId}
        inputAttributes={{ autoComplete: 'postal-code', ...inputAttributes }}
      />
    </NsInputter>
  );
};
